import { StrictMode } from 'react';

import type { DeploySurface } from '../lib/deploySurface';
import { AppProviders } from './providers';
import { SurfaceAppRouter } from './createAppRouter';

type SurfaceAppProps = {
  surface: DeploySurface;
};

export default function SurfaceApp({ surface }: SurfaceAppProps) {
  return (
    <StrictMode>
      <AppProviders>
        <SurfaceAppRouter surface={surface} />
      </AppProviders>
    </StrictMode>
  );
}
